import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { FormValidator } from '../../../services/form-validator/form-validator';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { AmToasterService } from '@angularminds/am-toaster';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  passwordVisible: boolean = false;
  oldPasswordVisible: boolean = false;
  confirmPasswordVisible: boolean = false;
  isButtonDisabled: boolean = false;
  validateStatus: string;
  customErrors: any = {};
  strength: any = {};

  isGoogleButtonDisabled: boolean = false;
  reCaptchaToken: string;
  isOffice365ButtonDisabled: boolean;
  organizationSettings: any = {
    enableLoginWith: {
      google: true,
      office365: true,
    },
  };
  isSubmitted: boolean;

  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private authService: AuthService,
    private generalService: GeneralService,
    private bsModalRef: BsModalRef,
    public router: Router,
    private amToasterService: AmToasterService,
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required, FormValidator.minLength(8)]],
      password: ['', [Validators.required, FormValidator.minLength(8)]],
      confirmPassword: ['', [Validators.required, FormValidator.minLength(8)]],
    });
  }

  applyValidations() {
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
    }
  }

  checkPasswordValidations(password: string) {
    this.validateStatus = 'validating';
    this.generalService.isPasswordStrong(password).then(isValid => {
      if (!isValid) {
        this.validateStatus = 'error';
        this.form.controls.password.setErrors({ notValid: true });
      } else {
        this.validateStatus = 'success';
      }
    });
  }

  disableWhiteSpace(event) {
    return FormValidator.restrictWhiteSpace(event);
  }

  checkConformPassword() {
    if (this.form.controls.password.value !== this.form.controls.confirmPassword.value) {
      this.customErrors.confirmPassword = 'Password and confirm password did not match!';
      this.form.controls.confirmPassword.setErrors({ notValid: true });
      return;
    } else {
      this.form.controls.confirmPassword.setErrors(undefined);
      this.customErrors.confirmPassword = undefined;
    }
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
  submitForm(): void {
    this.isSubmitted = true;
    this.applyValidations();
    // if (this.form.invalid || this.validateStatus !== 'success') {
    if (this.form.invalid) {
      return;
    }
    if (this.form.controls.password.value !== this.form.controls.confirmPassword.value) {
      this.customErrors.confirmPassword = 'Password and confirm password did not match!';
      this.form.controls.confirmPassword.setErrors({ notValid: true });
      return;
    }
    this.isButtonDisabled = true;
    const data = {
      oldPassword: this.form.value.oldPassword,
      password: this.form.value.password,
      confirmPassword: this.form.value.confirmPassword,
    };
    this.restService.put('/api/users/password', data).subscribe(
      response => {
        console.log('response', response);
        this.isButtonDisabled = false;
        // this.notification.success(`Success!`, `Your password has been changed, please re-login`);
        this.authService.logout().subscribe(result => {
          window.location.href = this.authService.getParentDomainRequestUrl('/auth/login');
        });
      },
      error => {
        // this.notification.error(`Oop's`, error);
        this.isButtonDisabled = false;

        this.amToasterService.show('error', error, 'Oops!');
      },
    );
  }

  get email() {
    return this.form.controls.email;
  }

  get password() {
    return this.form.controls.password;
  }

  get confirmPassword() {
    return this.form.controls.confirmPassword;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  doLogin(): void {
    this.authService.login(this.email.value, this.password.value, this.reCaptchaToken).subscribe(
      (response: any) => {
        this.isButtonDisabled = false;
        if (response && response.user && response.user._pre) {
          window.location.href = this.restService.getRequestUrl('/auth/second-factor');
        } else {
          if (this.authService.getRedirectionUrl()) {
            window.location.href = this.authService.getRedirectionUrl();
            this.authService.clearRedirectionUrl();
          } else {
            window.location.href = this.restService.getRequestUrl('/dashboard');
          }
        }
      },
      error => {
        this.isButtonDisabled = false;
      },
    );
  }
}
